export async function removeStoredValue(key) {
  return localStorage.removeItem(key);
}
